<template lang="pug">
  div(:class="{ bgblack: introBG}")
    transition(name="slideUp")
      .welcome(v-if='intro' @keyup.down="enter")
        transition(name="fade")
          .intro(v-if='!loading')
            .screen
              visual(:image="introImage" background="cover" role="img" aria-label="California African American Museum")
            .logo
              visual(image="static/logos/caam_logo_white.svg" alt="Caam Logo")
            .next(@click='enter')
              visual(image="static/icons/arrow_down_white.svg" alt="Scroll Arrow")
    transition(name="slideUpOffset")
      .main(v-if='!intro')
        top-nav(headerColor = "black")
        transition(name="fade")
          .home(v-if='!loading')
            .screen(key="first")
              router-link(
                :to="{name: 'exhibition-single', params: {year: startYear(exhibitionFirst), id: exhibitionFirst.uid }}"
              )
                visual(
                  :image="exhibitionFirst.mainImage"
                  background="cover"
                  role="img"
                  :aria-label="exhibitionFirst.title"
                )
                  .captions
                    h2
                      | exhibition
                    h1
                      | {{ title(exhibitionFirst) }}
                    h2
                      | {{ date(exhibitionFirst) }}
            div(v-if="!introBG")
              .screen(v-for="exhibition in exhibitions" :key="title(exhibition)")
                router-link(
                  :to="{name: 'exhibition-single', params: {year: startYear(exhibition), id: exhibition.uid }}"
                )
                  visual(
                    :image="exhibition.mainImage"
                    background="cover"
                    role="img"
                    :aria-label="exhibition.title"
                  )
                    .captions
                      h2
                        | exhibition
                      h1
                        | {{ title(exhibition) }}
                      h2
                        | {{ date(exhibition) }}
              .events
                h2
                  | upcoming programs
                .eventsContainer
                  .preview(v-for="program in programs")
                    router-link(
                      :to="{name: 'programs-page', params: {category: programCategory(program), id: program.uid }}"
                    )
                      visual(
                        :image="program.mainImage"
                        background="cover"
                        role="img"
                        :aria-label="program.content.title"
                      )
                      .eventCaptions
                        h1
                          | {{ program.content.title }}
                        .dateTime
                          h2
                            | {{ program.content.date }}
                          p
                            | {{ program.content.start_time }} - {{ program.content.end_time }}
              .explore
                h2
                  | explore
                .exploreContainer
                  swiper(:options="swiperOption" ref="gallery")
                    swiper-slide(v-for="item in explore" :key="item.text")
                      a(:href="item.link")
                        visual(
                          :image="item.image_url"
                          background="cover"
                          role="img"
                          :aria-label="item.text"
                        )
                        h2
                          | {{ item.text }}
                    .swiper-button-prev(slot="button-prev")
                    .swiper-button-next(slot="button-next")
        bottom-nav(footerColor="black" v-if="!introBG")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'home',
  mixins: [DataMixin, ComponentMixin],

  data () {
    return {
      // intro: this.$ls.get('intro'),
      // introBG: this.$ls.get('introBG'),
      intro: window._caam_intro,
      introBG: window._caam_introBG,
      first: true,
      mainImage: {},
      ready: false,
      swiperOption: {
        notNextTick: true,
        autoplay: false,
        direction: 'horizontal',
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        mousewheelControl: false,
        observeParents: true,
        debugger: true,
        onTransitionStart (swiper) {
          // console.log(swiper)
        }
      }
    }
  },

  created () {
    // this.intro = this.$ls.get('intro')
    // this.introBG = this.$ls.get('introBG')

    this.intro = window._caam_intro
    this.introBG = window._caam_introBG

    // Replace this
    window._caam_whiteHeader = false
    // this.$ls.set('whiteHeader', false)
    this.requestData('home', 'home')
    window.addEventListener('wheel', this.handleWheel)
    window.addEventListener('keydown', this.handleKey)

    // Set page title
    document.title = 'CAAM | California African American Museum'
  },

  destroyed () {
    window.removeEventListener('wheel', this.handleWheel)
    window.removeEventListener('keydown', this.handleKey)
  },

  methods: {
    enter: function () {
      window._caam_intro = false
      this.intro = window._caam_intro
      // this.$ls.set('intro', false)
      // this.intro = this.$ls.get('intro')
      setTimeout(() => {
        // this.$ls.set('introBG', false)
        // this.introBG = this.$ls.get('introBG')
        window._caam_introBG = false
        this.introBG = window._caam_introBG
      }, 1020)
    },

    handleWheel (e) {
      if (this.introBG) {
        e.preventDefault()
      }
      if (this.first && this.intro) {
        let debounce = true
        if (e.deltaY > 0 && debounce) {
          this.enter()
          debounce = false
        }
      }
    },

    handleKey (e) {
      if (this.introBG) {
        e.preventDefault()
      }
      if (this.first && this.intro) {
        let debounce = true
        if (e.keyCode === 40 && debounce) {
          this.enter()
          debounce = false
        }
      }
    },

    startDate: function (exhibition) {
      return exhibition.content.start_date
    },

    endDate: function (exhibition) {
      return exhibition.content.end_date
    },

    startYear: function (exhibition) {
      return exhibition.content.start_year
    },

    endYear: function (exhibition) {
      return exhibition.content.end_year
    },

    date: function (exhibition) {
      const endDate = this.endDate(exhibition) + ', ' + this.endYear(exhibition)
      let startDate = startDate = this.startDate(exhibition)
      if (this.endYear(exhibition) !== this.startYear(exhibition)) {
        startDate = this.startDate(exhibition) + ', ' + this.startYear(exhibition)
      }
      return startDate + ' - ' + endDate
    },

    title: function (exhibition) {
      return exhibition.content.title
    },

    programCategory: function (item) {
      return item.content.category.split(' ').join('-').toLowerCase()
    }
  },

  computed: {
    exhibitionFirst: function () {
      const first = this.loadedData.home.exhibitions.splice(0, 1)
      return first[0]
    },

    exhibitions: function () {
      return this.loadedData.home.exhibitions
    },

    programs: function () {
      return this.loadedData.home.programs
    },

    introImage: function () {
      return this.loadedData.home.intro.mainImage
    },

    swiper: function () {
      return this.$refs.gallery.swiper
    },

    explore: function () {
      return this.loadedData.home.intro.content.explore
    },

    key: function () {
      return 'home'
    }
  },

  watch: {
    $route: function () {
      // this.intro = this.$ls.get('intro')
      // this.introBG = this.$ls.get('introBG')
      this.intro = window._caam_intro
      this.introBG = window._caam_introBG
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/main'
  .home
    @include respond-to(xs)
      padding-top: 5rem
  .bgblack
    background-color: #000
  .screen
    height: 100vH
    @include respond-to(xs)
      height: 52vW
    .vv-image
      width: 100vW
      height: 100vH
      @include respond-to(xs)
        height: 52vW
      background-repeat: no-repeat
      background-size: cover
  .screen, .half-screen
    position: relative
    .captions
      position: absolute
      padding-bottom: $margin
      padding-top: 20vH
      bottom: 0
      width: 100vW
      color: #FFF
      background: linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.75))
      @include respond-to(xs)
        height: unset
      >*
        padding-left: $margin
        letter-spacing: $kerningTight
        line-height: 125%
        @include respond-to(xs)
          letter-spacing: $kerningTightMobile
  .welcome
    position: relative
    .logo
      position: absolute
      top: 50%
      left: 4vW
      @include translateY(-50%)
      .vv-image
        width: 92vW
    .next
      z-index: 10000
      position: absolute
      bottom: 3.8vH
      left: 46.08vW
      cursor: pointer
      .vv-image
        width: 3.92vW
  .events, .explore
    margin-top: 8.8rem
    @include respond-to(xs)
      margin-top: 4rem
    h1
      letter-spacing: $kerningMidTight
      @include respond-to(xs)
        font-size: 2.5rem
    h2
      padding-left: 0
      margin-left: $sectionMargin
      margin-bottom: 2rem
      letter-spacing: $kerningTight
      @include respond-to(xs)
        letter-spacing: $kerningTightMobile
        margin-left: 5%
        margin-bottom: 0.5rem
  .eventsContainer
    display: flex
    justify-content: flex-start
    @include respond-to(xs)
      display: block
    .preview
      width: 30%
      margin-left: 2.5vW
      @include respond-to(xs)
        width: 90%
        margin-left: 5%
        margin-bottom: 3rem
      &:hover h1
        border-bottom: solid 2px #000
        @include respond-to(xs)
          border-bottom: none
    .vv-image
      width: 100%
      height: 29vH
      @include respond-to(xs)
        height: 48vW
      background-repeat: no-repeat
      background-size: cover
      :hover
    .eventCaptions
      *
        padding-left: 0
        @include respond-to(xs)
          margin-left: 0
      h1
        display: inline
        border-bottom: solid 2px #FFF
        padding-top: 0.57rem
        font-size: 3rem
        font-style: normal
        line-height: 119%
        letter-spacing: $kerningTight
        @include respond-to(xs)
          font-size: 2rem
          letter-spacing: $kerningTightMobile
          line-height: 100%
          border-bottom: none
      h2
        font-size: 2rem
        margin-bottom: 0
        line-height: 130%
        letter-spacing: -0.1rem
        @include respond-to(xs)
          font-size: 1.2rem
      p
        letter-spacing: $kerningWide
        font-size: 1.8rem
        font-weight: 400
        margin-top: 0
        margin-bottom: 0
        line-height: 139%
        @include respond-to(xs)
          font-size: 1.2rem
          line-height: 160%
          &::before
            content: '  |  '
      .dateTime
        h2, p
          margin: 0
        @include respond-to(xs)
          display: flex
          justify-content: flex-start
  .exploreContainer
    width: 75vW
    margin: auto
    @include respond-to(xs)
      width: 90%
    h2, .swiper-slide, .vv-visual
      width: 65vW
      @include respond-to(xs)
        height: 48vW
        width: 90vW
    h2
      color: white
      margin: 0
      width: calc(65vw - 6rem)
      position: absolute
      padding: 3rem
      padding-top: 9rem
      bottom: 0
      line-height: 1.1
      font-size: 4.5rem
      opacity: 0
      pointer-events: none
      @include transition(opacity, 0.25s, ease-in-out)
      background: linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.5))
      @include respond-to(xs)
        font-size: 2rem
        opacity: 1
        padding: 0
        padding-left: 5%
        bottom: -85%
        width: 90%
    .swiper-slide
      display: flex
      justify-content: center
    .vv-visual
      &:hover + h2
        opacity: 1
    .vv-visual, .vv-image
      height: 65vH
      @include respond-to(xs)
        height: 52vW
    .vv-image
      min-width: 100%
      background-repeat: no-repeat
      background-size: cover
    .swiper-button-prev
      background-image: url('/static/icons/left_arrow.svg')
      @include respond-to(xs)
        display: none
    .swiper-button-next
      background-image: url('/static/icons/right_arrow.svg')
      @include respond-to(xs)
        display: none
</style>



// WEBPACK FOOTER //
// Home.vue?d1a4a484